$('.h-menu__open').on('click', function(){
  $('.h-menu').toggleClass('h-menu__show');
  $('.h-menu__open').toggleClass('h-menu__active');
});
$('.h-menu__close').on('click', function(){
  $('.h-menu').removeClass('h-menu__show');
  $('.h-menu__open').removeClass('h-menu__active');
});

$('.search-open').on('click', function(){
  $('.header-search__sp').toggleClass('active');
});

$('.dots-slider__item').on('click', function(){
  $(this).addClass('is-active');
  $('.dots-slider__item').not(this).removeClass('is-active');

  var index = $(this).index();
  $('.thumbnail-slider__item').removeClass('is-active');
  $('.thumbnail-slider__item').eq(index).addClass('is-active');
});

$(function(){
  var header__height = $('header').innerHeight();
  var pos = 0;
  var header = $('.header-search__sp');

  $(window).on('scroll', function(){
    var current_pos = $(this).scrollTop();
    if( current_pos >= pos && current_pos > 50){
      header.addClass('hide');
    } else {
      header.removeClass('hide');
    }
    pos = current_pos;
  });
});

// $('.js-slick').slick({
//   arrows: false,
//   autoplay: true,
//   autoplaySpeed: 0,
//   speed: 8000,
//   infinite: true,
//   pauseOnHover: false,
//   pauseOnFocus: false,
//   cssEase: 'linear',
//   slidesToShow: 3.6,
//   slidesToScroll: 1,
//   responsive: [
//     {
//     breakpoint: 834,
//     settings:{  
//       slidesToShow: 2.5,
//     }
//     },
//     {
//     breakpoint: 480,
//     settings:{
//       slidesToShow: 1.5,
//     }
//     }
//   ]
// });

// $('.product__slider').slick({
//   prevArrow: '<div class="slick-prev"></div>',
//   nextArrow: '<div class="slick-next"></div>',
//   dots:true,
//   customPaging: function(slick,index) {
//     // スライダーのインデックス番号に対応した画像のsrcを取得
//     let targetImage = slick.$slides.eq(index).find('img').attr('src');
//     // slick-dots > li　の中に上記で取得した画像を設定
//     return '<img src=" ' + targetImage + ' "/>';
//   }
// });

$(function ($) {
  $(".accordion-btn").click(function () {
    $(".accordion-btn").not(this).removeClass("open");
    $(".accordion-btn").not(this).next().slideUp(300);
    $(this).toggleClass("open");
    $(this).next().slideToggle(300);
  });
});

$(function(){
  if(window.matchMedia("(max-width: 480px)").matches){
    $(".category__list").css("display", "none");
    $(".accordion-btn--sp").click(function () {
      $(".accordion-btn--sp").not(this).removeClass("open");
      $(".accordion-btn--sp").not(this).next().slideUp(300);
      $(this).toggleClass("open");
      $(this).next().slideToggle(300);
    });
  }
});

function tabGethashID (tabhashIDName){
	if(tabhashIDName){
		//タブ設定
		$('.h-menu-tab li').find('a').each(function() { //タブ内のaタグ全てを取得
			var tabidName = $(this).attr('href'); //タブ内のaタグのリンク名（例）#lunchの値を取得	
			if(tabidName == tabhashIDName){ //リンク元の指定されたURLのハッシュタグ（例）http://example.com/#lunch←この#の値とタブ内のリンク名（例）#lunchが同じかをチェック
				var tabparentElm = $(this).parent(); //タブ内のaタグの親要素（li）を取得
				$('.h-menu-tab li').removeClass("active"); //タブ内のliについているactiveクラスを取り除き
				$(tabparentElm).addClass("active"); //リンク元の指定されたURLのハッシュタグとタブ内のリンク名が同じであれば、liにactiveクラスを追加
				//表示させるエリア設定
				$(".h-menu-tab__item").removeClass("show"); //もともとついているis-activeクラスを取り除き
				$(tabhashIDName).addClass("show"); //表示させたいエリアのタブリンク名をクリックしたら、表示エリアにis-activeクラスを追加	
			}
		});
	}
}

//タブをクリックしたら
$('.h-menu-tab a').on('click', function() {
	var tabidName = $(this).attr('href'); //タブ内のリンク名を取得	
	tabGethashID (tabidName);//設定したタブの読み込みと
	return false;//aタグを無効にする
});


// 上記の動きをページが読み込まれたらすぐに動かす
$(window).on('load', function () {
    $('.h-menu-tab li:first-of-type').addClass("active"); //最初のliにactiveクラスを追加
    $('.h-menu-tab__item:first-of-type').addClass("show"); //最初の.areaにis-activeクラスを追加
	var tabhashName = location.hash; //リンク元の指定されたURLのハッシュタグを取得
	tabGethashID (tabhashName);//設定したタブの読み込み
});

function GethashID (hashIDName){
	if(hashIDName){
		//タブ設定
		$('.tab__panel li').find('a').each(function() { //タブ内のaタグ全てを取得
			var idName = $(this).attr('href'); //タブ内のaタグのリンク名（例）#lunchの値を取得	
			if(idName == hashIDName){ //リンク元の指定されたURLのハッシュタグ（例）http://example.com/#lunch←この#の値とタブ内のリンク名（例）#lunchが同じかをチェック
				var parentElm = $(this).parent(); //タブ内のaタグの親要素（li）を取得
				$('.tab__panel li').removeClass("active"); //タブ内のliについているactiveクラスを取り除き
				$(parentElm).addClass("active"); //リンク元の指定されたURLのハッシュタグとタブ内のリンク名が同じであれば、liにactiveクラスを追加
				//表示させるエリア設定
				$(".tab__content").removeClass("show"); //もともとついているis-activeクラスを取り除き
				$(hashIDName).addClass("show"); //表示させたいエリアのタブリンク名をクリックしたら、表示エリアにis-activeクラスを追加	
			}
		});
	}
}

//タブをクリックしたら
$('.tab__panel a').on('click', function() {
	var idName = $(this).attr('href'); //タブ内のリンク名を取得	
	GethashID (idName);//設定したタブの読み込みと
	return false;//aタグを無効にする
});


// 上記の動きをページが読み込まれたらすぐに動かす
$(window).on('load', function () {
    $('.tab__panel li:first-of-type').addClass("active"); //最初のliにactiveクラスを追加
    $('.tab__content:first-of-type').addClass("show"); //最初の.areaにis-activeクラスを追加
	var hashName = location.hash; //リンク元の指定されたURLのハッシュタグを取得
	GethashID (hashName);//設定したタブの読み込み
});


// タブに対してクリックイベントを適用
const tabCollection = document.querySelectorAll(".tab-wrap");
if(tabCollection){
  tabCollection.forEach(function(tab){
    const tabs = tab.querySelectorAll(".tab__menu .js-tab");
    const collections = tab.querySelectorAll(".collections__box .js-panel");
    tabs.forEach(function(t, index){
      t.addEventListener('click', () => {
        tabs.forEach(function(tab, i){
          tab.classList.toggle('active', i === index);
        });
        collections.forEach(function(collection, i) {
          collection.classList.toggle('active', i === index);
        });
      });
    });
  })
}

//CATEGORY一覧のスクロールバー
const catListIn = document.querySelector('.p-catList__in');
const catListBar = document.querySelector('.p-catList__bar span');

if(catListIn && catListBar){
  function updateBar(){
    const scrollLeft = catListIn.scrollLeft;
    const maxScroll = catListIn.scrollWidth - catListIn.clientWidth;

    let percent = maxScroll > 0 ? (scrollLeft / maxScroll) * 100 : 0;
    if(scrollLeft >= maxScroll - 1) percent = 100;
    percent = Math.max(percent,10);
    catListBar.style.width = percent + '%';
  }
  catListIn.addEventListener('scroll',updateBar);
  document.addEventListener('DOMContentLoaded',updateBar);
  window.addEventListener('resize',updateBar);
}